import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Sidebar from './sidebar'; // './sidebar/index.js' 
import { useStaticQuery, graphql } from 'gatsby';
import Header from "./Header";
import Footer from "./footer.js";
import { Menu } from 'react-feather'; // メニューアイコン

// 配置スタイルを定義
const Wrapper = styled('div')`
  display: flex;
  min-height: 100vh; // ビューポート全体を使う
  flex-direction: column; // 縦に並べる
`;

// コンテンツのスタイルを定義
const Content = styled('div')`
  flex: 1;
  display: flex; // サイドバーとコンテンツを横に並べる
  margin-top: 60px; // ヘッダーの高さを考慮

  @media (max-width: 768px) {
    flex-direction: column; // モバイルでは縦に並べる
  }
`;

// サイドバーの背景を定義
const SidebarBackground = styled('div')`
  position: fixed;
  top: 0; // ヘッダーの高さを考慮（サイドバーのtopより少し小さい値に）
  left: 0;
  width: 310px; // サイドバーより少し大きくする
  bottom: 0; // ページの下まで伸ばす
  background-color: #F7FBFC; // 背景色
  z-index: 10; // フッターより前面に配置

  @media (max-width: 768px) {
    display: ${props => props.mobileSidebarVisible ? 'block' : 'none'};
    position: fixed;
    top: 0px; /* ← ヘッダーの高さに合わせる */
    left: 0;
    width: 100%; /* モバイルでは画面幅いっぱいに表示 */
    bottom: 0;
    background-color: #F7FBFC;
    z-index: 10;
  }
`;
// サイドバーの見え方を定義
const LeftSideBarWidth = styled('div')`
  width: 300px; // サイドバーの幅を設定
  position: fixed; // サイドバーを固定
  top: 100px; // ヘッダーの高さを考慮
  bottom: 0; // ページの下まで伸ばす
  overflow-y: auto; // コンテンツがオーバーフローした場合にスクロール
  background-color: #F7FBFC; // サイドバーの背景色を設定
  z-index: 12; // 背景より前面に表示

  @media (max-width: 768px) {
    display: ${props => props.mobileSidebarVisible ? 'block' : 'none'}; // モバイルでは非表示
    /* モバイルで表示するためのスタイル (ボタンで制御) */
    position: fixed;
    top: 100px; /* ヘッダーの下 */
    left: 0;
    bottom: 0;
    width: 100%;
    overflow-y: auto; 
    background-color: #F7FBFC;
    z-index: 12; /* トグルボタンより前面に */
  }

  /* モバイル以外でのスタイル */
  @media (min-width: 769px) {
    display: block; /* 常に表示 */
  }
  
`;

// コンテンツの最大幅を定義
const MaxWidth = styled('div')`
  /* モバイル以外でのマージン */
  @media (min-width: 769px) {
    margin-left: ${props => props.sidebarVisible ? '300px' : '0'};
  }
  flex: 1; // 残りのスペースを占有
  margin-top: 60px; // ヘッダーの高さを考慮

  @media (max-width: 768px) {
    margin-left: 0; // モバイルでは余白をリセット
    margin-right: 0; // モバイルでは余白をリセット
  }
`;

// コンテンツのスタイルを定義
const Container = styled('div')`
  max-width: 1200px; // 適切な最大幅を設定
  margin: 0 auto; // 中央寄せ
  padding: 0 20px; // 適切なパディングを設定
`;

// トグルボタンのスタイルを定義
const ToggleButton = styled('button')`
  position: fixed; // サイドバーを表示するボタン
  top: 60px; // 上からの距離
  left: 0px; // 左からの距離
  z-index: 20; // サイドバーより前面に配置
  background:none // ボタンの背景を透明に
  position: fixed; // 固定位置
  border: none; // ボーダーを非表示
  color: black; // ボタンの文字色
  border: none; // ボーダーを非表示
  padding: 6px; // パディング
  border-radius: 5px; // 角を丸くする
  cursor: pointer; // カーソルをポインターに
  font-size: 1.5em; // フォントサイズ

  @media (min-width: 769px) {
    display: none; /* デスクトップでは非表示 */
  }
`;

const FooterWrapper = styled('div')`
  background-color: #F7FBFC;
  text-align: center;
  z-index: 0;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;


// ヘッダー、サイドバー、コンテンツ、フッターを含むページ全体のレイアウトを定義
const Layout = ({ pageTitle, children, location }) => {
  const [sidebarVisible, setSidebarVisible] = useState(true); // デフォルトで表示するように設定
  const [mobileSidebarVisible, setMobileSidebarVisible] = useState(false); // モバイル用のサイドバー表示状態
  const [isMobile, setIsMobile] = useState(false); // モバイルの状態を追跡する新しいstate

  // クライアントサイドでモバイル表示かどうかを判断するEffect
  useEffect(() => {
    const handleResize = () => {
      const mobileCheck = window.innerWidth <= 768;
      setIsMobile(mobileCheck);
      if (!mobileCheck) { // デスクトップ表示になったらモバイルサイドバーは閉じる
        setMobileSidebarVisible(false);
      }
    };
    // 初期モバイル状態を設定
    handleResize();
    // ウィンドウのリサイズイベントリスナーを追加
    window.addEventListener('resize', handleResize);
    // コンポーネントのアンマウント時にイベントリスナーをクリーンアップ
    return () => window.removeEventListener('resize', handleResize);
  }, []); // 空の依存配列は、マウント時に1回実行され、アンマウント時にクリーンアップされる

  // staticQueryを使用してサイトメタデータを取得
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileSidebarVisible(!mobileSidebarVisible); // モバイルではモバイル用サイドバーの状態を切り替え
    } else {
      setSidebarVisible(!sidebarVisible); // モバイル以外では通常のサイドバーの状態を切り替え
    }
  };
  const closeMobileSidebar = () => {
    console.log("closeMobileSidebar called. Current isMobile state:", isMobile); // ★デバッグログ1
    if (isMobile) {
      setMobileSidebarVisible(false);
      console.log("setMobileSidebarVisible(false) was executed."); // ★デバッグログ2
    } else {
      console.log("Not mobile, or isMobile is false. Sidebar not closed by this function."); // ★デバッグログ3
    }
  };

  return (
    <Wrapper>
      <Header location={location} />
      <ToggleButton onClick={toggleSidebar}>
        <Menu size={24} />
      </ToggleButton>
      <div style={{ display: 'flex', flex: 1 }}>
        <SidebarBackground />
        <LeftSideBarWidth
          mobileSidebarVisible={mobileSidebarVisible}
        >
        <Sidebar location={location} onLinkClick={closeMobileSidebar} />
        </LeftSideBarWidth>
        <Content>
          <MaxWidth sidebarVisible={sidebarVisible}>
            <Container>
              <main>
                {children}
              </main>
            </Container>
          </MaxWidth>
        </Content>
      </div>
      <FooterWrapper>
        <Footer style={{ zIndex: 0 }} />
      </FooterWrapper>
    </Wrapper>
  );
  /*
  return (
      <Wrapper>
        <Header location={location} />
        <div style={{ display: 'flex', flex: 1 }}>
          <SidebarBackground />
          {sidebarVisible && ( // sidebarVisibleがtrueの時のみ表示
            <LeftSideBarWidth className={'hiddenMobile'}>
              <Sidebar location={location} />
            </LeftSideBarWidth>
          )}
          <Content>
            <MaxWidth>
              <Container>
                <main>
                  {children}
                </main>
              </Container>
            </MaxWidth>
          </Content>
        </div>
        <Footer style={{ zIndex: 0 }} />
      </Wrapper>
  );
  */
};


export default Layout;
